import React from "react";
import { Box, Typography } from "@mui/material";

const RelatorioEstoqueFooterTable = ({ fisico, reserv, saldo }) => {

    return (
        <>
            <Box className="relatorio-header-table relatorio-footer">
                <Box>
                    <Typography className="relatorio-header-column"></Typography>
                </Box>
                <Box>
                    <Typography className="relatorio-header-column nome-produto-column">
                        Total Estoque
                    </Typography>
                </Box>
                <Box>
                    <Typography className="relatorio-header-column">{fisico}</Typography>
                </Box>
                <Box>
                    <Typography className="relatorio-header-column">{reserv}</Typography>
                </Box>
                <Box>
                    <Typography className="relatorio-header-column">{saldo}</Typography>
                </Box>
            </Box>
        </>
    )
}

export default RelatorioEstoqueFooterTable;